(function(){
  // Translations & data from Liquid
  const {
    freeGiftVariantId    = '',
    freeGiftPriceDisplay = '',
    freeGiftPriceCents   = 0,
    freeLabelText        = 'FREE',
    changeButtonText     = 'Change',
    selectBothText       = 'Select both options.',
    unavailableText      = 'Variant unavailable.',
    errorText            = 'Something went wrong. Please try again.',
    addToCartText        = 'Add to cart',
    defaultLocale        = 'en',
    currentLocale        = ''
  } = window.bundleBuilderData || {};

  let currentSlot = null;
  const selectedVariants       = {};
  const productCache           = {};
  let didPrefetch             = false;
  const productPath = currentLocale && currentLocale !== defaultLocale ? `/${currentLocale}/products` : '/products'

  function prefetchAllProducts() {
    if (didPrefetch) return;
    didPrefetch = true;
    document.querySelectorAll('.product-item').forEach(item => {
      fetch(`${productPath}/${item.dataset.handle}.js`)
        .then(r => r.json())
        .then(js => { productCache[item.dataset.handle] = js; })
        .catch(() => {});
    });
  }

  function toggleBundleContent(){
    const hdr = document.querySelector('.bundle-header');
    const cnt = document.querySelector('.bundle-content');
    const divider = document.querySelector('.free-divider');
    if (!hdr || !cnt) return;
    const open = cnt.style.display === 'block';
    if (!open) {
      prefetchAllProducts();
      cnt.style.display = 'block';
      setTimeout(()=> divider?.scrollIntoView({behavior:'smooth',block:'center'}),100);
    } else {
      cnt.style.display = 'none';
      setTimeout(()=> hdr.scrollIntoView({behavior:'smooth',block:'end'}),100);
    }
    hdr.classList.toggle('active', !open);
  }

  function closeModal(){
    document.querySelector('.product-selector-modal')?.style.setProperty('display','none');
  }

  function openCartDrawer(){
    if (window.theme?.CartDrawer?.open) window.theme.CartDrawer.open();
    else if (window.theme?.cartDrawer?.open) window.theme.cartDrawer.open();
    else document.querySelector('[data-cart-toggle], [data-drawer-open="cart"], .iCartBtnToggle')?.click();
  }

  function updateSavings(){
    const paidCount = Object.keys(selectedVariants).filter(s=>s!=='5').length;
    const dimmed = paidCount < 3;
    document.querySelector('.bundle-slot[data-slot="4"]')?.classList[dimmed?'add':'remove']('dimmed');
    document.querySelector('.bundle-slot[data-slot="5"]')?.classList[dimmed?'add':'remove']('dimmed');
  }

  document.addEventListener('DOMContentLoaded', ()=>{
    if (!document.querySelector('.bundle-builder')) return;
    document.querySelector('.bundle-header')?.addEventListener('click', toggleBundleContent);

    // Initialize free slot
    selectedVariants[5] = freeGiftVariantId;
    updateSavings();

    // Open modal on slot click
    document.querySelectorAll('.bundle-slot, .free-selector').forEach(el=>{
      const slot = el.dataset.slot;
      if (slot==='5') return;
      el.addEventListener('click', ()=>{
        currentSlot = slot;
        document.querySelector('.product-selector-modal')?.style.setProperty('display','flex');
      });
    });

    // Modal close
    document.querySelector('.close-modal')?.addEventListener('click', closeModal);
    document.querySelector('.product-selector-modal')?.addEventListener('click', e=>{
      if (e.target===e.currentTarget) closeModal();
    });

    // Product selector logic
    document.querySelectorAll('.product-item').forEach(item=>{
      let data = null;
      const inline = item.querySelector('.inline-variants');
      const img = item.querySelector('.slider-image');
      const prev = item.querySelector('.slider-prev');
      const next = item.querySelector('.slider-next');
      const colorSelect = inline.querySelector('.variant-color');
      const sizeSelect = inline.querySelector('.variant-size');
      const confirmBtn = inline.querySelector('.confirm-variant');

      item.addEventListener('click', async e=>{
        if (e.target.closest('.inline-variants')) return;
        document.querySelectorAll('.product-item .inline-variants')
          .forEach(iv=> iv!==inline && (iv.style.display='none'));
        const wasOpen = inline.style.display==='block';
        inline.style.display = wasOpen?'none':'block';
        if (wasOpen) return;

        const handle = item.dataset.handle;
        if (!productCache[handle]) {
          try { productCache[handle] = await fetch(`${productPath}/${handle}.js`).then(r=>r.json()); }
          catch { return; }
        }
        data = productCache[handle];
        inline.dataset.loaded = 'true';

        const colors = [...new Set(data.variants.map(v=>v.options[0]))];
        const sizes  = [...new Set(data.variants.map(v=>v.options[1]))];
        colorSelect.innerHTML = colors.map(c=>`<option>${c}</option>`).join('');
        sizeSelect.innerHTML  = sizes.map(s=>`<option>${s}</option>`).join('');
        colorSelect.disabled = sizeSelect.disabled = false;
        confirmBtn.disabled   = false;

        data.images.forEach(u=>new Image().src=u);

        const setImage = ()=>{
          const chosen = data.variants.find(v=>
            v.options[0]===colorSelect.value &&
            (v.options[1]===sizeSelect.value||data.options.length===1)
          );
          if (chosen?.featured_image?.src) img.src = chosen.featured_image.src;
        };
        setImage();
        colorSelect.addEventListener('change', setImage);
        sizeSelect.addEventListener('change', setImage);

        let idx=0;
        const show=i=>img.src=data.images[idx=i];
        prev.addEventListener('click',ev=>{ev.stopPropagation();show((idx-1+data.images.length)%data.images.length)});
        next.addEventListener('click',ev=>{ev.stopPropagation();show((idx+1)%data.images.length)});
        img.addEventListener('touchstart',ev=>idx=ev.touches[0].clientX);
        img.addEventListener('touchend',ev=>{
          const endX=ev.changedTouches[0].clientX;
          if(endX-idx>50) prev.click();
          if(idx-endX>50) next.click();
        });
      });

      confirmBtn.addEventListener('click',ev=>{
        ev.stopPropagation();
        if (!inline.dataset.loaded) return;
        if (!colorSelect.value||!sizeSelect.value) return alert(selectBothText);

        const variant = data.variants.find(v=>
          v.options[0]===colorSelect.value &&
          (v.options[1]===sizeSelect.value||data.options.length===1)
        );
        if (!variant) return alert(unavailableText);

        const slotEl = document.querySelector(`.bundle-slot[data-slot="${currentSlot}"]`);
        const toHide = slotEl.querySelector('.open-selector')||slotEl.querySelector('.free-selector');
        if (toHide) toHide.style.display='none';

        const changeBtnOrTag = currentSlot==='4'
          ? `<span class="free-tag">${freeLabelText}</span>`
          : `<button class="change-product" data-slot="${currentSlot}" style="font-weight:300;">${changeButtonText}</button>`;

        slotEl.querySelector(`#slot-${currentSlot}-display`).innerHTML=`
          <div style="background:#fff;border:1px solid #ccc;padding:10px;border-radius:4px;
                      display:flex;justify-content:space-between;align-items:center;">
            <div style="display:flex;align-items:center;">
              <img src="${variant.featured_image?.src||item.dataset.image}" width="40"
                   style="margin-right:10px;border-radius:4px;">
              <div style="display:flex;flex-direction:column;line-height:1.2;">
                <span style="font-weight:300;">${item.dataset.title}</span>
                <span style="font-size:13px;color:#666;">
                  ${colorSelect.value}, ${sizeSelect.value}
                </span>
              </div>
            </div>
            ${changeBtnOrTag}
          </div>`;

        selectedVariants[currentSlot]=variant.id;
        updateSavings();
        if(Object.keys(selectedVariants).filter(s=>s!=='5').length>=3)
          document.querySelector('.bundle-submit')?.removeAttribute('disabled');
        closeModal();
      });
    });

    document.addEventListener('click',e=>{
      if (e.target.classList.contains('change-product')){
        currentSlot=e.target.dataset.slot;
        document.querySelector('.product-selector-modal')?.style.setProperty('display','flex');
      }
    });

    document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeModal(); });

    document.querySelector('.bundle-submit')?.addEventListener('click',async()=>{
      const btn=document.querySelector('.bundle-submit');
      btn.disabled=true;
      btn.innerHTML=`<div class="spinner" style="height:20px;width:20px;
                       border:2px solid #fff;border-top-color:transparent;
                       border-radius:50%;animation:spin 1s linear infinite;
                       margin:0 auto;"></div>`;

      const items=Object.entries(selectedVariants)
        .filter(([s])=>s!=='5')
        .map(([,vid])=>({id:Number(vid),quantity:1,properties:{bundle:"true"}}));

      try {
        const res=await fetch(`${window.Shopify.routes.root}cart/add.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items})
        });
        if(!res.ok) throw '';

        try {
          document.dispatchEvent(new CustomEvent('theme:cart:add',{bubbles:true,detail:{items}}));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh',{bubbles:true}));
        }catch{}

        await fetch(`${window.Shopify.routes.root}cart/update.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({attributes:{bundle:"true"}})
        });

        openCartDrawer();
      } catch {
        alert(errorText);
      } finally {
        btn.disabled=false;
        btn.innerHTML=addToCartText;
      }
    });
  });
})();
